module.exports = __webpack_public_path__ + "static/media/view2.5b596116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/view2.png
// module id = 224
// module chunks = 0